import { createReducer } from 'redux-act'
import u from 'updeep'

import { update } from 'actions/events-filters'

const initialState = {
  guests: undefined,
  date: undefined,
  location: undefined,
  tag: undefined,
}

export default createReducer({
  [update]: (state, { filter, value }) => {
    return u({ [filter]: value }, state)
  },
}, initialState)
